import "../../../libs/backbone/backbone.ajaxq.adapter.ts";

import GenericView from '../generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../../templates/helpers/countdownTimer.template.html';

import i18n  from "l10n";

import "../../../libs/jquery-countdown/js/jquery.countdown.min.js";

export default GenericView.extend({
    tagName: 'div',
	template: Handlebars.compile(Template),

	initialize: function (options) {
		var self = this;

        this.dateTo = options ? options.dateTo : new Date();
        this.callbackFunction = options ? options.callbackFunction : null;
        this.parentView = options ? options.parentView : null;

	},
	superRender: GenericView.prototype.render,
	render: function () {
	    this.superRender();

        var templateData = {

        };

        this.$el.html( this.template(templateData) );

        this.startCountdown(this.dateTo);

        return this;
	},
	events:{

	},
	getFormattedRemainingMinutes: function(minutes) {
	    return Handlebars.helpers.getFormattedRemainingMinutes(minutes);
	},
	startCountdown: function(dateTo) {
	    var self = this;

        //pass a `dateTo`, in case the timer has already begun and for some reason the page was reloaded,
        //so the timer can know from which time to start the countdown (continue with the current remaining time and not the initial one)
	    var finalDate = dateTo.getTime();

        this.$el.find('.countdownTimer').countdown(finalDate)
        .off('update.countdown').on('update.countdown', function(event) {
            $(this).text(event.strftime('%S'));
        }).off('finish.countdown').on('finish.countdown', function(event) {
            self.setCountDownDefaultValue();

            if(self.callbackFunction && self.parentView) {
                self.callbackFunction(self.parentView);
            }
        }).off('stop.countdown').on('stop.countdown', function(event) {

        });
	},
	setCountDownDefaultValue: function() {
        this.$el.find(".countdownTimer").text("30");
	}
});

